import { newE2EPage } from "@stencil/core/testing";
import { GuidedTourStep } from "../types";
import testDelay from "../../../../test-utils/test-delay";

const testStep: GuidedTourStep = {
    target: ".test-target",
    title: "Step 1 Title",
    body: "Step 1 Description",
    targetOffset: 20,
    placement: "bottom-start"
};

describe("guided-tour-overlay", () => {
    it("should render with backdrop, focus area and popover correctly", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-guided-tour-overlay step-index="1" total-steps="5"></ux-guided-tour-overlay>`);
        const el = await page.find("ux-guided-tour-overlay");
        await page.waitForChanges();
        expect(el).toHaveClass("hydrated");
        el.setProperty("step", testStep);
        el.setProperty("targetRect", {
            x: 10,
            y: 20,
            width: 200,
            height: 100
        });
        await page.waitForChanges();
        await testDelay(200);
        await page.waitForChanges();
        await page.find(".ux-popover__overlay--opened");
        expect(el).toMatchSnapshot();
    });
});
